<template>
    <v-alert class="text-center" style="position:absolute !important;width:99% !important;z-index: 11;" v-bind:type="alert.type" v-model="alert.show" dismissible>{{ alert.message }}</v-alert>
</template>

<script>
import {mapActions, mapState} from 'vuex'
export default {
    data() {
        return{

        }
    },
    computed: {
        ...mapState({alert: state => state.alerts})
    },

    watch: {
        '$store.state.alerts.show'(value){
            if (value){
                window.scrollTo(0,0)

                setTimeout(()=> {
                    this.clear()
                }, 6000)
            }
        }
    },
    methods: {
        ...mapActions('alerts', ['clear'])
    }
}
</script>

<style>
.v-alert{z-index: 10}
</style>
